/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-23 11:24:19
 * @modify date 2021-08-23 11:24:19
 * @desc [枚举]
 */
/**
 * @export 平台枚举
 * @enum x-client-info:platform={平台};version={版本号}
 */
export enum EnumPlatform {
  /** 桌面PC */
  desktop = 'desktop',
  /** 手机H5 */
  mobile = 'mobile',
  /** 后台管理 */
  bgm = 'bgm',
  /** 微信小程序 */
  weapp = 'weapp',
  /** 微信公众号 */
  wechat = 'wechat',
  /** app */
  app = 'app',
}
/**
 * @export 登陆类型
 * @enum
 */
export enum EnumLoginType {
  /** 手机号 */
  mobile = 'mobile',
  /** 账号 */
  account = 'account',
  /** 微信 */
  wechat = 'wechat',
  /** 注册 */
  registered = 'registered',
  /** SMB注册 */
  smbRegister = 'smbRegister',
}
/**
 * @export 微信授权类型
 * @enum
 */
export enum EnumWechatAuthorizeState {
  /** 授权登录 */
  login = 'login',
}
/**
 * @export 短信验证码发送场景
 * @enum
 */
export enum EnumPhoneMsgScene {
  /** 注册 */
  register = 1,
  /** 登录 */
  login = 2,
  /** 修改密码 */
  editPwd = 3,
  /** 修改手机号 校验手机号 */
  editPhone = 4,
  /** 绑定新手机号 */
  bindPhone = 5,
  /** 微信绑定手机号 */
  wechatBindPhone = 6,
  /** 政企（大客户）注册 */
  relRegister = 7,
  /** 服务站账号激活 */
  serviceStation = 8,
  /** SMB快速注册 */
  smbRegister = 9,
}
/**
 * @export 验证码类型
 * @enum
 */
export enum EnumCaptchaType {
  /** 短信验证码 */
  mobile = 1,
  /** 邮箱验证码 */
  email = 2,
}
/**
 * @export 图形验证码类型
 * @enum
 */
export enum EnumImgCodeType {
  /** account */
  account = 1,
  /** lenovoid */
  lenovoid = 2,
}
export enum EnumStatusCode {
  /** 身份为sales */
  salesAuth = 4001,
  /** 未认证的l2 */
  L2Auth = 4002,
  /** 已认证-未绑定k码 l2 */
  bindKcode = 4003,
  /** 已认证-未绑定手机号 l2 */
  bindMobile = 4004,
  /** 个人中心-我的商机-sales权限 */
  salesToBu = 4005,
  /** bu为isg或者con */
  isgOrcon = 4006,
  /** bu未签约 */
  sign = 4007,
  /** 服务器错误 */
  serverError = 500,
  /** 404错误 */
  notFound = 404,
  /** 新用户 */
  newUser = 'AAuthorization-1017',
  /** 低强度密码 */
  lowPwd = 'AAccount-1008',
  /** 强制重置密码 */
  resetPwd = 'AUserData-1012',
}

/**
 * @export 注册来源
 * @enum
 */
export enum EnumRegisterSource {
  /** pc */
  pc = 1,
  /** mobile */
  mobile = 2,
  /** weapp */
  weapp = 3,
}

/**
 * @export 登录来源
 * @enum
 */
export enum EnumLoginWay {
  /** 账号密码登录 */
  PWD_LOGIN = 1,
  /** 手机号登录 */
  SMS_LOGIN = 2,
  /** 微信登录 */
  WECHAT_LOGIN = 3,
  /** 切换登录 */
  SWITCH_LOGIN = 4,
  /** ITcode 登录 */
  AD_LOGIN = 5,
  /** 单点登录 */
  SSO_LOGIN = 6,
  /** lenovoid 登录 */
  LENOVO_LOGIN = 7,
}
